import Request from 'utilities/Request';

export const fetchView = viewId =>
  Request.get(`/api/content/v2/views/${viewId}`);
